import React, { useState, useEffect } from "react";
import { Column, DataGrid, Button } from "devextreme-react/data-grid";
import { api_path } from "../../shared";
import CustomStore from "devextreme/data/custom_store";
import AddServiceDataModal from "./AddServiceDataModal";
const CustomerServiceUsage = ({ CRM_CUSCODE }) => {
  const token = process.env.REACT_APP_API_TOKEN;
  const url = api_path + "/customer/customer_details.php";
  const [detailDataSource, setDetailDataSource] = useState(null);
  useEffect(() => {
    if (CRM_CUSCODE) {
      const store = new CustomStore({
        key: "SERVICE_USE_ID",
        load: () => {
          return fetch(`${url}?CRM_CUSCODE=${CRM_CUSCODE}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
            .then((res) => {
              if (!res.ok) {
                throw new Error("Network response was not ok");
              }
              return res.json();
            })
            .catch((error) => {
              console.error("Error loading data:", error);
              return [];
            });
        },
      });
      setDetailDataSource(store);
    }
  }, [CRM_CUSCODE]);

  return (
    <div className="">
      <br />
 <AddServiceDataModal
                    CUSTOMER_CODE={CRM_CUSCODE}
                  />
      <DataGrid
        dataSource={detailDataSource}
        showBorders={false}
        keyExpr="SERVICE_USE_ID"
      >
        <Column dataField="LOADPORT" />
        <Column dataField="POL_NAME" />
        <Column dataField="DISCHARGE_PORT" />
        <Column dataField="T20" />
        <Column dataField="T40" />
        <Column dataField="T40HQ" />
        <Column dataField="T45" />
        <Column dataField="R20" />
        <Column dataField="R40" />
        <Column dataField="ISOTANK" />
        <Column dataField="SPECIAL" />
        <Column dataField="AIR_GW" />
        <Column dataField="LCL_CBM" />
        <Column dataField="INCOTERM_EXW" />
        <Column dataField="INCOTERM_FOB" />
        <Column dataField="INCOTERM_CIF" />
        <Column dataField="INCOTERM_DAP" />
      </DataGrid>
    </div>
  );
};

export default CustomerServiceUsage;
